import { Component } from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams} from 'ionic-angular';
import {DummyDataProvider} from "../../providers/dummy-data/dummy-data";

/**
 * Generated class for the EventDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-event-details',
  templateUrl: 'event-details.html',
})
export class EventDetailsPage {

  public event: ReadycashEvent;
  public loading: boolean = true;

  constructor(public navCtrl: NavController, protected navParams: NavParams, protected dataService: DummyDataProvider, protected alertCtrl : AlertController) {
  }

  ionViewDidLoad() {
    const event = this.navParams.get('event');
    console.log({event});
    this.initializeEvent(event)
  }


  initializeEvent(event){
    this.event = event;
    setTimeout(()=> this.loading = false, 1000)
    // this.dataService
  }

  get hasWinners(){
    return !!(this.event && this.event.winners && this.event.winners.length);
  }

  closeChallenge(){
    const alert = this.alertCtrl.create({
      title: 'Closed Challenge',
      cssClass: 'ready-alert',
      message: 'This challenge has ended',
      buttons:[
        {
          text: 'Continue',
          cssClass: 'cta',
        },
        {
          text: 'Continue',
          cssClass: 'cta outline',
        }
      ]
    });
    alert.present()
  }

  naira(number) {
    return Number(number || 0).toLocaleString("en-NG", {
      currency: "NGN",
      currencyDisplay: "symbol",
      style: "currency"
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/event-details/event-details.ts